import { map, Observable, of } from 'rxjs';
import { IAuction, ICapacityReturnRequest, ICapacityReturnResponse, ISourceAuction } from '.';
import { axiosToObservable } from '../core/clients/axiosToObservable';
import { BidClient } from '../core/clients';
import { ExchangeCode, ExchangeId } from './Auction.service';

export class CapacityReturnService  {
    getSourceAuctionsForReturn = (auction: IAuction): Observable<ISourceAuction[]> => {
        return axiosToObservable(BidClient.post<ISourceAuction[]>('capacityReturn/sourceAuction', {
          auctionId: auction.identification,
          exchangeCode: ExchangeCode.Empire,
          exchangeId: ExchangeId.Empire,
        })).pipe(
          map((results: ISourceAuction[]) => {
            return results || ([] as ISourceAuction[]);
          })
        );
      };

  /**
   * Submits a capacity return request
   * @param request The capacity return request data
   * @returns Observable of capacity return response
   */
  returnSubmission(request: ICapacityReturnRequest): Observable<ICapacityReturnResponse> {
    return axiosToObservable(BidClient.post<ICapacityReturnResponse>('capacityReturn/submission', request)).pipe(
        map((response: ICapacityReturnResponse) => {
          return response;
        })
      );
  }
}
